import { memo } from 'react';
import { ProductLoader } from './ProductLoader';

function ProductLoaderList() {
    return (
        <>
            {Array.from({ length: 6 }).map((_, index) => {
                const key = `loader-${index}`;

                return <ProductLoader key={key} uniqueKey={key} />;
            })}
        </>
    );
}

export default memo(ProductLoaderList);
